import React from 'react'
import { Sidebar, FormBillPayment, BillPaymentPlaceholder } from './'
import PropTypes from 'prop-types'
import { Alert } from 'loyal-react'
import ModalTerms from '../CellphoneRecharge/ModalTerms/ModalTerms'
import '@loyal_template/services.css'
import { SecondFactorAuthentication } from 'features/Checkout/SecondFactorAuthenticaton'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

import TitlePrint from 'App/Shell/TitlePrint'

import { ToggleFeature, features } from 'features/ToggleFeature'

const showError = (error, handlerCloseError) =>
  error ? (
    <Alert
      isError
      title={error.title}
      description={error.description}
      className='pb-2'
      onClose={() => handlerCloseError()}
    />
  ) : (
    ''
  )

const showSuccess = (success, handlerCloseSuccess) =>
  success ? (
    <Alert
      isSuccess
      title={success.title}
      description={success.description}
      className='pb-2'
      onClose={() => handlerCloseSuccess()}
    />
  ) : (
    ''
  )

const BillPayment = ({
  isloading,
  isLoadingChangeAccountType,
  maskLengthAccountType,
  maskAccountType,
  accountType,
  handlerChangeAccountType,
  handleBarCodeChange,
  handlerGetData,
  handlerFinalizePayment,
  handlerCloseError,
  handlerCloseSuccess,
  billValue,
  pointsValue,
  isPriceEditable,
  barCode,
  dueDate,
  errorPage,
  successPage,
  errorField,
  name,
  loadingPayment,
  showTerms,
  closeterms,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  vendorId,
  catalogId,
  serviceId,
  handleBarCodeBlur,
  currencyConfiguration,
  handleCoversionPointsValue,
  handleBillValue,
  handleDueDate,
  dueDateType,
  oidc,
  secondFactorAuthentication,
  closeSecondFactorModal,
  authorizeWithTokenResend,
  authorizeWithToken,
  authorizeWithTokenData,
  secondFactorAuthConfirmated,
  secondFactorAuthenticationOrderId,
  phone
}) => (
  <ReactPlaceholder
    ready={!isloading}
    customPlaceholder={<BillPaymentPlaceholder />}
  >
    <TitlePrint page={'Pagamento de contas'} />
    <div className='container-fluid px-0 px-md-1 pt-0'>
      <div className='container pt-0 pb-3 py-md-5'>
        <div className='row align-items-start pt-0'>
          {showError(errorPage, handlerCloseError)}
          {showSuccess(successPage, handlerCloseSuccess)}
          <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '>
            <div className='row mx-0'>
              <div className='col-12 radius border border-color-ui-3'>
                <div className='row'>
                  <div className='col-12'>
                    <div className='bg-paguecontas radius-top row align-items-center px-1'>
                      <div className='col-12 px-3'>
                        <h2 className='color-ui-white txt-title-2 txt-circular-book'>
                          Pagamento de contas
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row radius-bottom bg-white px-1'>
                  <div className='col-12 px-2 py-2'>
                    <p className='txt-body-sm'>
                      Você sabia que pode utilizar seus{' '}
                      {currencyConfiguration.pointsName} para pagar contas de
                      luz, telefone, água, entre outras? Aproveite e leve mais
                      facilidade e economia para a sua vida.
                    </p>
                  </div>

                  <ToggleFeature feature={features.BillpaymentCustomTerms} />

                  <div className='col-12 px-3 pb-3'>
                    <FormBillPayment
                      dueDateType={dueDateType}
                      maskLengthAccountType={maskLengthAccountType}
                      maskAccountType={maskAccountType}
                      accountType={accountType}
                      handlerChangeAccountType={handlerChangeAccountType}
                      handleBarCodeChange={handleBarCodeChange}
                      handlerGetData={handlerGetData}
                      billValue={billValue}
                      pointsValue={pointsValue}
                      isPriceEditable={isPriceEditable}
                      barCode={barCode}
                      errorField={errorField}
                      dueDate={dueDate}
                      isloading={isloading}
                      isLoadingChangeAccountType={isLoadingChangeAccountType}
                      serviceId={serviceId}
                      handleBarCodeBlur={handleBarCodeBlur}
                      handleCoversionPointsValue={handleCoversionPointsValue}
                      handleBillValue={handleBillValue}
                      handleDueDate={handleDueDate}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalTerms
            show={showTerms}
            terms={{
              type: 'Vendor',
              vendorId: vendorId,
              catalogId: catalogId
            }}
            onClose={closeterms}
            acceptTerms={() => acceptTermsEvent(true)}
          />
          <Sidebar
            barCode={barCode}
            name={name}
            data={dueDate}
            billValue={billValue}
            pointsValue={pointsValue}
            handlerFinalizePayment={handlerFinalizePayment}
            loadingPayment={loadingPayment}
            showTermsEvent={showTermsEvent}
            acceptTermsEvent={acceptTermsEvent}
            acceptTerms={acceptTerms}
            serviceId={serviceId}
            accountType={accountType}
          />
        </div>
      </div>
    </div>
    {secondFactorAuthentication && (
      <div className='modalConfirmationVoucher'>
        <SecondFactorAuthentication
          show
          onClose={() => closeSecondFactorModal()}
          paymentSelected='POINTS_ONLY'
          paymentPoints={null}
          oidc={oidc}
          confirmedOrderId={secondFactorAuthenticationOrderId}
          closeModal={closeSecondFactorModal}
          authorizeWithTokenResend={authorizeWithTokenResend}
          authorizeWithToken={authorizeWithToken}
          loadingResendToken={
            authorizeWithTokenData &&
            authorizeWithTokenData.loadingResendToken
          }
          isCreatingPurchase={
            authorizeWithTokenData &&
            authorizeWithTokenData.isCreatingPurchase
          }
          errorToken={authorizeWithTokenData && authorizeWithTokenData.errorToken}
          secondFactorAuthConfirmated={secondFactorAuthConfirmated}
          phone={phone}
        />
      </div>
    )}
  </ReactPlaceholder>
)

BillPayment.propTypes = {
  isloading: PropTypes.bool,
  isLoadingChangeAccountType: PropTypes.bool,
  loadingPayment: PropTypes.bool,
  maskLengthAccountType: PropTypes.number,
  maskAccountType: PropTypes.array,
  accountType: PropTypes.array,
  handlerChangeAccountType: PropTypes.func,
  handleBarCodeChange: PropTypes.func,
  handlerGetData: PropTypes.func,
  handlerFinalizePayment: PropTypes.func,
  handlerCloseError: PropTypes.func,
  handlerCloseSuccess: PropTypes.func,
  billValue: PropTypes.number,
  pointsValue: PropTypes.number,
  isPriceEditable: PropTypes.bool,
  barCode: PropTypes.string,
  dueDate: PropTypes.string,
  name: PropTypes.string,
  errorPage: PropTypes.object,
  successPage: PropTypes.object,
  errorField: PropTypes.bool,
  showTerms: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  closeterms: PropTypes.func,
  acceptTerms: PropTypes.bool,
  acceptTermsEvent: PropTypes.func,
  vendorId: PropTypes.string,
  catalogId: PropTypes.string,
  serviceId: PropTypes.string,
  handleBarCodeBlur: PropTypes.func,
  currencyConfiguration: PropTypes.object,
  handleCoversionPointsValue: PropTypes.func,
  handleBillValue: PropTypes.func,
  oidc: PropTypes.object,
  handleDueDate: PropTypes.func,
  dueDateType: PropTypes.string,
  secondFactorAuthentication: PropTypes.bool,
  closeSecondFactorModal: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  authorizeWithTokenData: PropTypes.object,
  secondFactorAuthConfirmated: PropTypes.bool,
  secondFactorAuthenticationOrderId: PropTypes.number,
  phone: PropTypes.string
}

export default BillPayment



// WEBPACK FOOTER //
// ./src/features/BillPayment/BillPayment.js